import React, {useState} from 'react';

export default function ShowCalendar(props) {
  const daysOfWeekFull = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const currentDate = new Date();
  const [year, setYear] = useState(currentDate.getFullYear());
  const [month, setMonth] = useState(currentDate.getMonth());
  const firstDay = new Date(year, month, 1).getDay(); console.log('firstDay : ', firstDay) //
  const firstDayBefore = new Date(year, month - 1, 1).getDay(); console.log('firstDayBefore : ', firstDayBefore)// 
  const dimDay = [6, 13, 20, 27, 34];
  const lastDay = new Date(year, month + 1, 0).getDate();
  const lastDayBefore = new Date(year, month, 0).getDate();
  const prevMonthDays = firstDay === 0 ? 6 : firstDay - 1;
  const prevMonthDaysBefore = firstDayBefore === 0 ? 6 : firstDayBefore - 1;
  const numDays = lastDay + prevMonthDays; console.log('numDays : ', numDays);
  const numDaysBefore = lastDayBefore + prevMonthDaysBefore; console.log('numDaysBefore : ', numDaysBefore);
  const handlePrev = () => {
    setYear(month === 0 ? year - 1 : year);
    setMonth(month === 0 ? 11 : month - 1);
  };
  const handleNext = () => {
    setYear(month === 11 ? year + 1 : year);
    setMonth(month === 11 ? 0 : month + 1);
  };
  const openDayPlanning = (day, month, year, weekday) => {
    weekday = weekday < 7 ? weekday : weekday % 7;
    console.log('Open day : ', daysOfWeekFull[weekday], day, month, year);
    props.setOpenDay({
      disp: true,
      dayName: daysOfWeekFull[weekday],
      day: day,
      month: month,
      year: year,
    });
  }
  return (
    <>
        <p className="show_month" style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
          <span
              className="month_cursor"
              style={{left: '25px'}}
              onClick={handlePrev}>
            &laquo;
          </span>
          <span className="show_month_year">{monthNames[month]} {year}</span>
          <span
              className="month_cursor"
              style={{right: '25px'}}
              onClick={handleNext}>
            &raquo;
          </span>
        </p>
        <div className="weekdays">
          {daysOfWeekFull.map((day, index) => <div key={day} translate="no">{day.substring(0, 3)}</div>)}
        </div>
        <div className="days">
          {[...Array(numDays).keys()].map((day, index) => {
            if (index < prevMonthDays) {
               return (
                <span key={index} className={dimDay.includes(index) ? "sunday" : "one_day"} style={{color: 'darkgray', fontSize: '16px'}}>
                  -
                </span>
              )
            } else {
              return (
                <div
                    key={index}
                    onClick={() => {
                      if (!dimDay.includes(index)) {
                        openDayPlanning(
                            day - prevMonthDays + 1,
                            monthNames[month],
                            year,
                            index,
                      )}
                    }}>
                    <span className={dimDay.includes(index) ? "sunday" : "one_day"}>
                      {day - prevMonthDays + 1}
                    </span>
                </div>);
            }
          })}
        </div>
      </>
  )
}
